import {
  Button,
  FormControl,
  FormErrorMessage,
  Grid,
  Box,
  Center,
  Input,
  Checkbox,
  FormLabel,
  Flex,
  Spinner,
  InputGroup,
  Select,
  Heading,
  InputRightElement,
  Stack,
  Text,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { loginUser } from "../signupSteps/service";
import { FaRegTimesCircle } from "react-icons/fa";
import LoginAlternative from "./LoginAlternative";
import { enterOTP } from "./service";
import { ImBackward, ImForward2 } from "react-icons/im";
import splash from "../../assets/splash.jpg";
import image from "../../assets/image.jpeg";
import arrow from "../../assets/arrow.svg";
import logo from "../../assets/logo.png";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { useRef } from "react";
import { useEffect } from "react";
import { useGetState } from "../../context/useGetState";

function OTPScreen({ next, prev, totalStep }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [theOtpCode, setOtpCode] = useState(sessionStorage.getItem('code') || undefined);
  const navigate = useNavigate();
  const { dispatch } = useGetState();

  const inputRefs = [useRef(), useRef(), useRef(), useRef()]; // Create refs for the input fields
  const [otp, setOtp] = useState(["", "", "", ""]); // Initialize OTP as an array of empty strings
  const storeUserDetails = (details) => {
    dispatch({ userInfo: details?.user });
    sessionStorage.setItem("acc_type", details?.user?.account_type);
    sessionStorage.setItem("#f8WEB#", details?.token);
    sessionStorage.setItem("#f8WEB-firebase-success#", true);
  };

  useEffect(() => {
    // Set the initial focus to the first input field when the component is mounted
    inputRefs[0].current?.focus();
  }, []);

  // const handleInput = (e, index) => {
  //   const value = e.target.value;
  //   console.log('entr: ', value?.length );
  //   console.log('index: ', index);

  //   // Move to the next input field if a digit is entered
  //   if (value?.length === 1 && index < 3) {
  //     inputRefs[index + 1].current?.focus();
  //   }

  //   // Move to the previous input field if the input is deleted
  //   if (value?.length === 0 && index > 0) {
  //     inputRefs[index - 1].current?.focus();
  //   }
  // };

  const handleInput = (e, index) => {
    const value = e.target.value;

    // Ensure that only single digits are entered
    if (/^\d*$/.test(value) && value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Automatically move to the next input field if a digit is entered
      if (index < 3 && value?.length === 1) {
        const nextInput = e.target?.nextElementSibling;
        if (nextInput) {
          nextInput?.focus();
        }
      }
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Retrieve the OTP input values and concatenate them into a single token
    // const code1 = values.code1;
    // const code2 = values.code2;
    // const code3 = values.code3;
    // const code4 = values.code4;
    // const token = code1 + code2 + code3 + code4;

    // Concatenate the OTP array to get the complete OTP
    const otpToken = otp.join("");
    console.log('token: ', otpToken);
    const email = sessionStorage.getItem("email");
    const username = sessionStorage.getItem("username");
    const password = sessionStorage.getItem("password");

    const formData = new FormData();
    formData.append("code", otpToken);
    formData.append("email", email);
    formData.append("username", username);
    formData.append("password", password);

    
    const result = await enterOTP(formData, next, setLoading); 
    console.log('result: ', result);
    
    // console.log('result: ', result);
    if (result) {
     
      const promise2 = loginUser({ login: email, password });
      Promise.all([promise2])
        .then(function (values) {
          const promiseResolved = values?.[0]?.data;
  
          storeUserDetails(promiseResolved);
  
          // setLoading(false);
          navigate("/register/bio") 
    
          //
          // window.location.href = "/dashboard";
        })
        .catch((e) => {
          console.log('error',e)
          // setLoading(false);
          // errorNotifier(e?.response?.data?.message);
        });

    } else {
      return false
    }
    //result ? navigate("/register/bio") : navigate("/register/otp");
  };

  const handleNext = () => {
    next(); // Call the prev function to go back to EmailScreen
  };

  // Function to handle going back to the previous step
  const handlePrev = () => {
    prev(); // Call the prev function to go back to EmailScreen
    sessionStorage.setItem("totalStep", "otpscreen");
  };

  const stage = sessionStorage.getItem("totalStep");

  return (
    <Center
      backgroundImage={splash}
      h={{
        base: "100vh",
        sm: "100vh",
        md: "100vh",
        lg: "100vh",
        xl: "100vh",
        "2xl": "100vh",
      }}
    >
      <Grid>
        <Box
          as="form"
          onSubmit={handleOtpSubmit}
          backgroundColor={"#020B19"}
          mb={{ base: "0", sm: "0", md: "0", lg: "0", xl: "0", "2xl": "0" }}
          mt={{
            base: "2em",
            sm: "2em",
            md: "2em",
            lg: "2em",
            xl: "2em",
            "2xl": "2em",
          }}
          h={{
            base: "90vh",
            sm: "85vh",
            md: "90vh",
            lg: "88vh",
            xl: "80vh",
            "2xl": "80vh",
          }}
          w={{
            base: "100vw",
            sm: "100vw",
            md: "60vw",
            lg: "60vw",
            xl: "60vw",
            "2xl": "60vw",
          }}
          borderWidth={1}
          borderColor={"#66666680"}
          borderRadius={{
            base: "0",
            sm: "0",
            md: "24px",
            lg: "24px",
            xl: "24px",
            "2xl": "24px",
          }}
          boxShadow="lg"
          p={{
            base: "25px",
            sm: "15px",
            md: "40px",
            lg: "25px",
            xl: "25px",
            "2xl": "15px",
          }}
        >
          <Stack
            direction={{ base: "column", md: "row" }}
            mt={{
              base: "5em",
              sm: "5em",
              md: "2em",
              lg: "0em",
              xl: "0em",
              "2xl": "3em",
            }}
          >
            <Flex
              p={"2%"}
              color={"white"}
              flex={1}
              align={"center"}
              justify={"center"}
              ml={"5px"}
            >
              <Stack spacing={4} w={"full"} maxW={"md"}>
                <Box>
                  <Link to="/register">
                    <Image
                      alt={"Login Image"}
                      marginBottom={"10px"}
                      width={"29px"}
                      src={arrow}
                      mt={"-50px"}
                    />
                  </Link>

                  <Heading
                    color={"#ffffff"}
                    paddingTop={1}
                    fontSize={"28px"}
                    fontWeight={500}
                    letterSpacing={0}
                    lineHeight={"normal"}
                  >
                    One Time Password
                  </Heading>
                  <Flex>
                    <Text
                      fontWeight={400}
                      fontFamily={("Poppins-Regular", "Helvetica")}
                      color={"white"}
                      fontSize={"15px"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                    >
                      An OTP has been sent to your email address
                      {/* {theOtpCode && <span>Enter this code: {theOtpCode}, to continue</span>} */}
                    </Text>
                  </Flex>
                </Box>

                <Stack direction="row" spacing={2}>
                  {otp.map((digit, index) => (
                    <FormControl key={index}>
                      <Input
                        value={digit}
                        onChange={(e) => handleInput(e, index)}
                        max={9} // Enforce a maximum of 1 character
                        min={0} // Enforce a minimum of 0 character
                        type="number"

                        color={"white"}
                        borderColor={"#66666680"}
                        variant={"outline"}
                        borderWidth={1}
                        backgroundColor={"#020B19"}
                      />
                    </FormControl>
                  ))}
                </Stack>

                <Flex gap={4} display={"none"}>
                  <FormControl id="code1">
                    <Input
                      ref={inputRefs[0]} // Assign the ref to the input field
                      onInput={(e) => handleInput(e, 0)} // Handle input for the first field
                      {...register("code1", { required: true })}
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      type="number"
                      min={0} 
                      max={1}
                    />
                  </FormControl>
                  <FormControl id="code2">
                    <Input
                      ref={inputRefs[1]} // Assign the ref to the input field
                      onInput={(e) => handleInput(e, 1)} // Handle input for the first field
                      {...register("code2", { required: true })}
                      
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      type="number"
                      min={0} 
                      max={9}
                    />
                  </FormControl>
                  <FormControl id="code3">
                    <Input
                      ref={inputRefs[2]} // Assign the ref to the input field
                      onInput={(e) => handleInput(e, 2)} // Handle input for the first field
                      {...register("code3", { required: true })}
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      type="number"
                    />
                  </FormControl>
                  <FormControl id="code4">
                    <Input
                      ref={inputRefs[3]} // Assign the ref to the input field
                      onInput={(e) => handleInput(e, 3)} // Handle input for the first field
                      {...register("code4", { required: true })}
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      type="number"
                    />
                  </FormControl>
                </Flex>

                <Stack spacing={6}>
                  <Stack
                    direction={{ base: "column", sm: "row" }}
                    align={"start"}
                    justify={"space-between"}
                  ></Stack>

                  <Stack
                    align={{
                      base: "center",
                      sm: "center",
                      md: "end",
                      lg: "end",
                      xl: "end",
                      "2xl": "end",
                    }}
                  >
                    <Button
                      borderRadius={24}
                      bg={"#0076FF"}
                      w={"150px"}
                      type="submit"
                      h={"50px"}
                      variant={"solid"}
                    >
                      {loading ? <Spinner /> : "Continue"}
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            </Flex>

            <Flex
              justify="center"
              align="center"
              display={["none", "none", "none", "flex"]}
            >
              <Image
                alt={"Login Image"}
                marginTop={6}
                height={"350px"}
                width={"250px"}
                objectFit={"cover"}
                src={logo}
              />
            </Flex>
          </Stack>
        </Box>
        <Flex mr={5} ml={5} justify={"space-between"}>
          <Box>
            <Select
              fontFamily={("Poppins-Regular", "Helvetica")}
              fontSize={".9em"}
              color={"white"}
              w="auto"
            >
              <option value="en"> English(Unites states)</option>
            </Select>
          </Box>
          <Box mt={2}>
            <Flex mr={10} justify={"space-evenly"}>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                color={"white"}
              >
                Help
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Privacy
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Terms
              </Text>
            </Flex>
          </Box>
        </Flex>
      </Grid>
    </Center>
  );
}

export default OTPScreen;
